<template>
  <div class="content" id="dailyReport" @scroll="scrollChange">
    <div class="details">
      <div class="header">
        <h4 class="title">遥感日报</h4>
      </div>

      <div v-show="!showD"> 
        <div class="search">
          <van-field v-model="keyword"  label=""  placeholder="请输入关键字"  left-icon="search" />
        </div>
        <div class="reports">
          <div class="report" v-for="item in reports" :key="item.id" @click="seeDetail(item.id)">
            <img :src="`https://api.obtdata.com/orbita_cloud/resource/file/${item.thumbUuid}`" />
            <div class="imgFooter">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
        <van-pagination @change="changePage" mode="simple" v-model="pageParams.pageNumber" :total-items="total" :items-per-page="pageParams.pageSize" />
      </div>
      <div class="details_content" v-show="showD">
        <div class="search">
          <span @click="showD=false" style="color:#2581e8;font-size:14px">遥感日报  >  </span>
          <span style="color:#2581e8;font-size:14px"> 日报详情</span>
        </div>
        <div style="margin-top:10px;"><b>{{details.title}}</b></div>
        <div style="color:#787878;font-size:14px;margin-top:10px;">发布时间：{{details.time}}</div>
        <div v-html="details.contentDetail"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReportsReq,getReportsDetails } from '@/api/dailyReport'

export default {
  name: 'dailyReport',
  data () {
    return {
      keyword: '',
      pageParams: {
        pageNumber: 1,
        pageSize: 10
      }, 
      showD:false,
      total: 0,
      reports: [],
      details:{
        contentDetail:'',
        title:''
      },
      header: null,
    }
  },
  watch:{
    keyword:function(newVal){
      this.getReports()
      
    }
  },
  created () {
    this.getReports()
  },
  mounted () {
    this.header = document.querySelector('.el-header');
  },
  beforeDestroy () {
    // console.log('销毁前');
    if (document.querySelector('.el-header')) {
      document.querySelector('.el-header').className = 'header el-header';
    }
  },
  methods: {
    async seeDetail(id){
      const res = await getReportsDetails(id)
      this.details.contentDetail=res.data.data.curr.content
      this.details.title=res.data.data.curr.title
      this.details.time=res.data.data.curr.formattedCreateTime
      this.showD=true
    },
    scrollChange (e) {
      if (e.target.scrollTop > 240) {
        this.header.className = "header el-header inder-header scrollHeader";
      } else {
        this.header.className = this.header.className.replace('scrollHeader', "");
      }
    },
    changePage(val){
      this.pageParams.pageNumber=val
      this.getReports()
    },
    async getReports () {
      const params = {
        searchValue: this.keyword,
        pageNumber:this.pageParams.pageNumber-1,
        pageSize:this.pageParams.pageSize
      }
      const res = await getReportsReq(params)
      const resData = res.data
      if (resData.code == 200) {
        this.reports=resData.data.content
        this.total=resData.data.totalElements
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
.content
  width 100%
  height 100%
  overflow-y scroll
.details
  .header
    width 100%
    height 40vw
    padding-top 60px
    box-sizing border-box
    background url('~@/assets/content/banner.png') 0 0 no-repeat
    background-size 100% 100%
  .title
    width 100%
    text-align center
    font-size 18px
    line-height 25px
    font-weight bold
    color #fff
  .search
    background #edf6fa
    padding 8px
    >>> .van-field
      padding 4px
  .reports
    display grid
    grid-template-columns repeat(2, 1fr)
    column-gap 10px
    row-gap 5px
    padding 10px
    // overflow-y scroll
    .report
      box-sizing border-box
      font-size 12px
      position relative
      &.van-cell
        padding 0
      img
        width 100%
      .imgFooter
        position absolute
        box-sizing border-box
        padding 0 5px
        bottom 4px
        width 100%
        height 30%
        color #fff
        display flex
        align-items center
        background linear-gradient(0deg,rgba(0,0,0,.5),rgba(0,0,0,.3))
.details_content
  padding 10px
  font-size 16px
</style>